import analyticsRequest from "@/utils/request_analytics";

// ==================== Project Settings ====================

export function getProjectSettings(projectCode: string) {
	return analyticsRequest.get(`/analytics/project_settings/${projectCode}`);
}

export function updateProjectSettings(projectCode: string, data: any) {
	return analyticsRequest.put(`/analytics/project_settings/${projectCode}`, data);
}

// ==================== Overview ====================

export function getPlatformOverview(projectCode: string) {
	return analyticsRequest.get(`/analytics/overview/${projectCode}`);
}

// ==================== Documents ====================

export function deleteDocument(docId: string) {
	return analyticsRequest.delete(`/analytics/document/${docId}`);
}

export function getDocumentsBatch(projectCode: string, docIds: string[]) {
	return analyticsRequest.post(`/analytics/documents/${projectCode}/batch`, { doc_ids: docIds });
}

// ==================== Topics ====================

export function listTopics(projectCode: string, params?: {
	status?: string; skip?: number; limit?: number;
	search?: string; source_doc_id?: string; variant_type?: string;
}) {
	const { status, skip, limit, search, source_doc_id, variant_type } = params || {};
	return analyticsRequest.get(`/analytics/topics/${projectCode}`, {
		params: { triage_status: status, offset: skip, limit, search, source_doc_id, variant_type }
	});
}

export function triageTopic(topicId: string, data: { action: string; edits?: any }) {
	return analyticsRequest.post(`/analytics/topic/${topicId}/triage`, data);
}

// Re-grade all topics against the current 数据画像 (deterministic, no LLM) and re-rank.
export function rescoreTopics(projectCode: string) {
	return analyticsRequest.post(`/analytics/topics/${projectCode}/rescore`);
}

// ==================== 自动探索 (autopilot) ====================

// Start one autopilot cycle now: discover topics → auto-explore analysis →
// insight cards. The backend returns immediately (the cycle runs in the
// background for hours); 409 = a cycle is already in flight on this boot.
export function runAutopilotNow(projectCode: string) {
	return analyticsRequest.post(`/analytics/autopilot/${projectCode}/run`);
}

// Per-topic job ledger + recent cycles; data.running = a cycle is in flight.
export function getAutopilotJobs(projectCode: string, limit = 50) {
	return analyticsRequest.get(`/analytics/autopilot/${projectCode}/jobs`, { params: { limit } });
}

// ==================== 治疗回顾 Inbox ====================

export function listInboxInsights(projectCode: string, params?: { limit?: number; offset?: number; unread_only?: boolean }) {
	return analyticsRequest.get(`/analytics/insights/${projectCode}/inbox`, { params });
}

export function markInsightsRead(projectCode: string, payload: { insight_ids?: string[]; all?: boolean }) {
	return analyticsRequest.post(`/analytics/insights/${projectCode}/read`, payload);
}

